/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AcceptSubcontractingContractTermsRequest } from './';
import {
    AcceptSubcontractingContractTermsRequestFromJSON,
    AcceptSubcontractingContractTermsRequestFromJSONTyped,
    AcceptSubcontractingContractTermsRequestToJSON,
} from './';
import type { AcceptTripartiteContractTermsRequest } from './';
import {
    AcceptTripartiteContractTermsRequestFromJSON,
    AcceptTripartiteContractTermsRequestFromJSONTyped,
    AcceptTripartiteContractTermsRequestToJSON,
} from './';
import type { InvoicingMode } from './';
import {
    InvoicingModeFromJSON,
    InvoicingModeFromJSONTyped,
    InvoicingModeToJSON,
} from './';

/**
 * 
 * @export
 * @interface AcceptContractTermsRequest
 */
export interface AcceptContractTermsRequest {
    /**
     * 
     * @type {InvoicingMode}
     * @memberof AcceptContractTermsRequest
     */
    invoicingMode: InvoicingMode;
}

/**
 * Check if a given object implements the AcceptContractTermsRequest interface.
 */
export function instanceOfAcceptContractTermsRequest(value: object): value is AcceptContractTermsRequest {
    if (!('invoicingMode' in value) || value['invoicingMode'] === undefined) return false;
    return true;
}

export function AcceptContractTermsRequestFromJSON(json: any): AcceptContractTermsRequest {
    return AcceptContractTermsRequestFromJSONTyped(json, false);
}

export function AcceptContractTermsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptContractTermsRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['invoicingMode'] === 'SUBCONTRACTING') {
            return AcceptSubcontractingContractTermsRequestFromJSONTyped(json, true);
        }
        if (json['invoicingMode'] === 'TRIPARTITE') {
            return AcceptTripartiteContractTermsRequestFromJSONTyped(json, true);
        }
    }
    return {
        
        'invoicingMode': InvoicingModeFromJSON(json['invoicingMode']),
    };
}

export function AcceptContractTermsRequestToJSON(value?: AcceptContractTermsRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.invoicingMode === 'SUBCONTRACTING') {
            return AcceptSubcontractingContractTermsRequestToJSON(value as AcceptSubcontractingContractTermsRequest);
        }
        if (value.invoicingMode === 'TRIPARTITE') {
            return AcceptTripartiteContractTermsRequestToJSON(value as AcceptTripartiteContractTermsRequest);
        }
    }
    return {
        
        'invoicingMode': InvoicingModeToJSON(value['invoicingMode']),
    };
}

